// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__169Hq","col":"Table_col__11YW-","fulfillmentStatus":"Table_fulfillmentStatus__18l_t","emailCol":"Table_emailCol__o9LUE"};